import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./NoWorkplacePrompt.scss";

const NoWorkplacePrompt = () => {
  const { t } = useTranslation();

  const steps = [
    t("app.homeDashboard.noWorkplaceStep1"),
    t("app.homeDashboard.noWorkplaceStep2"),
    t("app.homeDashboard.noWorkplaceStep3"),
  ];

  return (
    <section className="home-dashboard-setup" aria-labelledby="home-dashboard-setup-title">
      <div className="home-dashboard-setup__card">
        <div className="home-dashboard-setup__glow" aria-hidden />
        <div className="home-dashboard-setup__inner">
          <div className="home-dashboard-setup__icon-wrap" aria-hidden>
            <i className="bi bi-building" />
          </div>
          <div className="home-dashboard-setup__content">
            <p className="home-dashboard-setup__eyebrow">{t("app.homeDashboard.noWorkplaceEyebrow")}</p>
            <h2 id="home-dashboard-setup-title" className="home-dashboard-setup__title">
              {t("app.homeDashboard.noWorkplaceTitle")}
            </h2>
            <p className="home-dashboard-setup__lead">{t("app.homeDashboard.noWorkplaceLead")}</p>
            <ol className="home-dashboard-setup__steps">
              {steps.map((step, index) => (
                <li key={index} className="home-dashboard-setup__step">
                  <span className="home-dashboard-setup__step-num" aria-hidden>
                    {index + 1}
                  </span>
                  <span>{step}</span>
                </li>
              ))}
            </ol>
            <p className="home-dashboard-setup__hint">{t("app.homeDashboard.noWorkplaceHint")}</p>
            <div className="home-dashboard-setup__actions">
              <Link to="/workplaces" className="home-dashboard-setup__cta">
                <i className="bi bi-building home-dashboard-setup__cta-icon" aria-hidden />
                <span>{t("app.homeDashboard.goToWorkplaces")}</span>
                <i className="bi bi-arrow-right home-dashboard-setup__cta-arrow" aria-hidden />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NoWorkplacePrompt;
